import { useState } from "react";
import { downloadCsv } from "@/lib/manufacturing/inventoryCsvExport";
import {
  namedVariantsToCsv,
  type NamedVariantExportRow,
} from "@/lib/manufacturing/namedVariantsCsvExport";

function stamp(): string {
  return new Date().toISOString().slice(0, 10);
}

export function useManufacturingNamedVariantsExport() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  function exportCsv(variants: ReadonlyArray<NamedVariantExportRow>) {
    if (variants.length === 0) return;
    setBusy(true);
    setError(null);
    downloadCsv(`mfg-named-variants-${stamp()}.csv`, namedVariantsToCsv(variants));
    setBusy(false);
  }

  return { busy, error, exportCsv, clearError: () => setError(null) };
}
